import styled from 'styled-components';
import { darken, rgba } from 'polished';

import _Modal from './Modal';

interface WeekDayInfoProps {
  isClosed: boolean;
}

export const Container = styled.div`
  font-family: 'Sora', sans-serif;
  padding: 50px;
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};

  * {
    letter-spacing: 0px;
    line-height: initial;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoints.xxl}px) {
    padding: 30px;
  }

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    padding: 20px;
  }
`;

export const Wrapper = styled.div`
  max-width: 1500px;
  width: 100%;
  position: relative;

  > header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;

    @media only screen and (max-width: ${({ theme }) =>
        theme.breakpoints.lg}px) {
      flex-direction: column;
      justify-content: center;
      text-align: center;

      > span {
        padding-top: 20px;
      }

      > button {
        margin-top: 15px;
      }
    }

    h1 {
      font-weight: 700;
      color: ${({ theme }) => theme.colors.black};
      font-size: 28px;
      letter-spacing: 0px;
    }

    h3 {
      color: ${({ theme }) => theme.colors.grey};
      font-weight: 400;
      padding-top: 5px;
    }

    span {
      color: ${({ theme }) => theme.colors.softBlack};

      strong {
        font-weight: 700;
      }
    }

    button {
      display: flex;
      align-items: center;
      padding: 13px 18px;
      border-radius: 5px;
      background-color: ${({ theme }) => theme.colors.main};
      border: none;
      transition: background-color 0.2s ease;

      span {
        font-family: 'Sora', sans-serif;
        font-size: 15px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.white};
      }

      &:hover {
        background-color: ${({ theme }) => darken(0.03, theme.colors.main)};
      }

      &:hover {
        background-color: ${({ theme }) => darken(0.03, theme.colors.main)};
      }

      &.outline {
        background-color: ${({ theme }) => theme.colors.white};
        border: 1px solid ${({ theme }) => theme.colors.main};

        span {
          color: ${({ theme }) => theme.colors.main};
        }

        &:hover {
          background-color: ${({ theme }) => rgba(theme.colors.main, 0.1)};
        }
      }

      & + button {
        margin-left: 10px;
      }
    }
  }
`;

export const Content = styled.main`
  padding: 50px 0 10px;
  display: flex;

  > div.hours {
    display: flex;
    flex: 1;
    max-width: 50px;
    flex-direction: column;
    margin-top: 126px;
    justify-content: space-between;
  }

  > div.week-days {
    flex: 1;

    > header {
      display: flex;
    }
  }
`;

export const WeekDays = styled.div`
  display: flex;
  flex: 1;
`;

export const WeekDayInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  h3 {
    color: ${({ theme }) => theme.colors.softBlack};
  }
`;

export const WeekDayStatus = styled.div<WeekDayInfoProps>`
  display: flex;
  align-self: center;
  justify-content: center;
  width: 160px;
  border-radius: 20px;
  padding: 7px 20px;
  border: 1px solid
    ${({ isClosed, theme }) =>
      isClosed ? theme.colors.red : theme.colors.green};
  margin: 20px 0 30px;

  span {
    font-size: 13px;
    color: ${({ isClosed, theme }) =>
      isClosed ? theme.colors.red : theme.colors.green};
  }
`;

export const Modal = styled(_Modal)`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  padding: 15px 20px;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h3 {
      font-weight: 700;
      color: ${({ theme }) => theme.colors.black};
    }

    button {
      padding: 5px;
      background: none;
      border: none;
      font-size: 26px;
      color: ${({ theme }) => theme.colors.red};
      max-width: 36px;
      max-height: 36px;
      transition: color 0.2s ease;

      &:hover {
        color: ${({ theme }) => darken(0.3, theme.colors.red)};
      }
    }
  }

  main {
    div.week-days {
      display: flex;
      border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};
      padding: 20px 0 30px;

      div.week-day {
        display: flex;
        width: 50px;
        flex-direction: column;
        align-items: center;

        input {
          margin-top: 10px;
        }
      }
    }

    div.options {
      padding: 20px 0 30px;

      div.option {
        display: flex;
        align-items: center;

        input {
          margin-right: 5px;
        }

        & + div.option {
          margin-top: 8px;
        }
      }

      button {
        display: flex;
        align-items: center;
        padding: 13px 18px;
        border-radius: 5px;
        background-color: ${({ theme }) => theme.colors.main};
        border: none;
        transition: background-color 0.2s ease;

        span {
          font-family: 'Sora', sans-serif;
          font-size: 15px;
          font-weight: 600;
          color: ${({ theme }) => theme.colors.white};
        }

        &:hover {
          background-color: ${({ theme }) => darken(0.03, theme.colors.main)};
        }

        &:hover {
          background-color: ${({ theme }) => darken(0.03, theme.colors.main)};
        }

        &.outline {
          background-color: ${({ theme }) => theme.colors.white};
          border: 1px solid ${({ theme }) => theme.colors.main};

          span {
            color: ${({ theme }) => theme.colors.main};
          }

          &:hover {
            background-color: ${({ theme }) => rgba(theme.colors.main, 0.1)};
          }
        }

        & + button {
          margin-left: 10px;
        }
      }
    }

    div.schedules-weekday {
      > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 8px 8px;

        button {
          padding: 5px;
          background: none;
          border: none;
          font-size: 20px;
          color: ${({ theme }) => theme.colors.red};
          max-width: 36px;
          max-height: 36px;
          transition: color 0.2s ease;
          font-size: 20px;

          &:hover {
            color: ${({ theme }) => darken(0.3, theme.colors.red)};
          }
        }
      }
    }

    div.edit-schedule {
      width: 300px;
      display: flex;
      align-items: center;
      padding: 20px 0 15px;

      select {
        margin: 0 8px;
      }

      button.delete {
        background: none;
        border: none;
        padding: 5px;
        font-size: 18px;
        color: ${({ theme }) => theme.colors.red};
      }
    }

    div.delivery-methods {
      display: flex;
      gap: 0.625rem;
      margin: 0.625rem 0;

      div {
        display: flex;
        align-items: center;
        gap: 0.25rem;
      }
    }
  }

  footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    button {
      display: flex;
      align-items: center;
      padding: 13px 18px;
      border-radius: 5px;
      background-color: ${({ theme }) => theme.colors.main};
      border: none;
      transition: background-color 0.2s ease;

      span {
        font-family: 'Sora', sans-serif;
        font-size: 15px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.white};
      }

      &:hover {
        background-color: ${({ theme }) => darken(0.03, theme.colors.main)};
      }

      &.outline {
        background-color: ${({ theme }) => theme.colors.white};
        border: 1px solid ${({ theme }) => theme.colors.main};

        span {
          color: ${({ theme }) => theme.colors.main};
        }

        &:hover {
          background-color: ${({ theme }) => rgba(theme.colors.main, 0.1)};
        }
      }

      & + button {
        margin-left: 10px;
      }
    }
  }
`;
